// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider, onAuthStateChanged, signInWithPopup, signOut } from 'firebase/auth';
import { useState, useEffect } from 'react';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD_Z2-_RlCE7h5TNh7-gARfr8oCpy_zF-U",
  authDomain: "mediopuntoapp.firebaseapp.com",
  projectId: "mediopuntoapp",
  storageBucket: "mediopuntoapp.appspot.com",
  messagingSenderId: "6096539360",
  appId: "1:6096539360:web:df1a1ea1059ff13a684a85",
  measurementId: "G-77VNK9M4MY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const signInWithGoogle = () => {
  const auth = getAuth(app);
  const provider = new GoogleAuthProvider();
  
  signInWithPopup(auth, provider).catch((error) => {
    // Silently log the error but don't throw
    // This prevents the uncaught error from crashing the app
    console.error('Firebase Auth Error:', error.code, error.message);
  });
};
  
  const firebaseSignOut = () => {
    signOut(getAuth(app))
        .then(() => {
            // empty local storage
            localStorage.removeItem('newUser');
            localStorage.removeItem('userData');
            localStorage.removeItem('GoogleData');
            // Redirect after successful sign out
            window.location.href = '/';
        })
        .catch((error) => {
            // Handle errors here
            console.error('Sign out error', error);
        });
};

// Client-specific sign out (doesn't redirect automatically)
const clientSignOut = () => {
    return signOut(getAuth(app))
        .then(() => {
            // Clear Firebase-related data
            localStorage.removeItem('newUser');
            localStorage.removeItem('userData');
            localStorage.removeItem('GoogleData');
            // Return success - let the calling component handle navigation
            return true;
        })
        .catch((error) => {
            // Handle errors here
            console.error('Client sign out error', error);
            return false;
        });
};

  
  export { firebaseSignOut as signOut, clientSignOut };
  
  export const useAuthState = () => {
    const [user, setUser] = useState();
    
    useEffect(() => (
      onAuthStateChanged(getAuth(app), setUser)
    ), []);
  
    return [user];
  };